<template>
  <v-row class="justify-center">
    <Form
      :items="dataInputs"
      @save="saveEdit"
      @cancel="reset"
      :maxWidth="maxWidth[0]"
      :mode="mode"
      :show="true"
      :itemsSelect="dataSelects"
      :readonly="this.stateReadonly"
    />

    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import currentAccounts from "@/store/currentAccounts/currentAccounts";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "../commons/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      stateReadonly: true,
      unitType: [
        {
          text: "Dias",
          value: "D",
        },
        {
          text: "Horas",
          value: "H",
        },
      ],
      oldItems: null,
      title: this.$tc("modelsLiquidations.modelsLiquidations"),
      titleDelete: this.$tc("modelsLiquidations.toModelLiquidation"),
      isLoading: true,
      maxWidth: ["900px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      showCard: true,
      itemId: null,
      showModelRelation: false,
      dataInputs: [
        {
          name: "nombre",
          label: this.$tc("CurrentAccounts.nameLabel"),
          data: "",
          type: "text",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
        {
          name: "descripcion",
          label: this.$tc("CurrentAccounts.descLabel"),
          data: "",
          type: "text",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ],
    };
  },
  async mounted() {
    try {
      this.setEdit();
      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },

  computed: {
    padding() {
      return currentAccounts.state.paddingNav;
    },

    dataSelects() {
      return [
        {
          name: "unidad",
          label: this.$tc("CurrentAccounts.TypeLabel"),
          data: "",
          items: this.unitType,
          itemsValue: "value",
          itemsText: "text",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
          icon: "",
        },
      ];
    },
    mode: {
      get() {
        return currentAccounts.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  methods: {
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    async saveEdit(newItems) {
      const payload = this.detectChanges(newItems);

      if (Object.keys(payload).length !== 0) {
        payload.accountId = this.oldItems.accountId;
        try {
          currentAccounts.commit("setEdit", payload);
          currentAccounts.dispatch("edit").then(() => {
            this.showAlert(
              this.$tc("CurrentAccounts.editCurrentAccountSuccess"),
              "success",
              true
            );
          });
        } catch (e) {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        }
      }
      this.reset(false);
    },

    detectChanges(newItems) {
      const changes = {};
      if (this.oldItems) {
        if (this.oldItems.name !== newItems.nombre) {
          changes.name = newItems.nombre;
        }

        if (this.oldItems.description !== newItems.descripcion) {
          changes.description = newItems.descripcion;
        }

        if (this.oldItems.unit !== newItems.unidad) {
          changes.unit = newItems.unidad;
        }
      }
      return changes;
    },

    reset() {
      this.stateReadonly = true;
    },

    cardView(value) {
      this.showCard = value;
    },

    async setEdit() {
      this.oldItems = await currentAccounts.state.edit;
      this.dataInputs[0].data = this.oldItems.name;
      this.dataInputs[1].data = this.oldItems.description;
      this.dataSelects[0].data = this.oldItems.unit;
    },
  },
};
</script>
